import {
  fetchMembershipPlan,
  fetchMembershipPlans,
} from '../endpoints/api';
import {fetchMembershipStripeLinkWithAnalytics} from '../utils/membershipCheckout';
import {useQuery} from '@tanstack/react-query';

export function useFetchMembershipStripeURL(
  membershipId: number,
  userId?: number,
  enabled: boolean = true,
) {
  return useQuery(
    ['membership_stripe', membershipId, userId],
    () => fetchMembershipStripeLinkWithAnalytics({membershipId}),
    {
      enabled: enabled && typeof membershipId === 'number' && typeof userId === 'number',
      cacheTime: 0, // Don't save in cache because stripe URLs should be generated everytime
    }
  );
}

export function useFetchMembershipPlans() {
  return useQuery(['memberships'], () => fetchMembershipPlans());
}

export function useFetchMembershipPlan(membershipId: number, enabled: boolean = true) {
  return useQuery(['membership', membershipId], () => fetchMembershipPlan(membershipId), {
    enabled: enabled && typeof membershipId === 'number',
  });
}
